import { frontendURL } from '../../../helper/URLHelper';
import EmailIndex from './pages/EmailIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/email'),
    component: EmailIndex,
    name: 'email_dashboard_index',
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/email/:folder'),
    component: EmailIndex,
    name: 'email_dashboard_folder',
    meta: commonMeta,
  },
];
